import { Link } from "react-router-dom";
import { FormActions } from "../../components/common/FormActions";
import { TTableColumn } from "../../types/common";
import { beautify, createViewEdit, numberFormat } from "../../utils/helpers";

export const useInventoryPurchaseOrder = () => {
  const tableColumns = (): TTableColumn[] => [
    { id: "purchase_order_number", header: "Order Number" },
    { id: "quantity", header: "Quantity" },
    { id: "quantity_received", header: "Quantity Receieved" },
    { id: "unit_price", header: "Unit Price" },
    { id: "total_price", header: "Total Amount" },
    { id: "condition", header: "Condition" },
    { id: "actions", header: "Actions" },
  ];

  const tableData = (data: any) =>
    data.map((item: any) => ({
      ...item,
      condition: beautify(item?.condition),
      unit_price: numberFormat(item?.unit_price),
      total_price: numberFormat(item?.total_price),
      quantity_received: item?.quantity_received || "0",
      //   purchase_order_number: item?.purchase_order?.purchase_order_number,
      purchase_order_number: (
        <Link to={`/purchase_order/view/${item?.purchase_order?.id}`}>
          {item?.purchase_order?.purchase_order_number}
        </Link>
      ),
      actions: (
        <FormActions actions={createViewEdit("/purchase_order", item?.id)} />
      ),
    }));

  const viewData = (item: any) => {
    return {
      sections: [
        {
          title: "Order Information",
          fields: {
            purchase_order_number: item?.purchase_order_number,
            supplier: item?.supplier_name,
            purchase_order_date: item?.purchase_order_date,
            payment_type: item?.payment_type,
            total_amount: numberFormat(item?.total_amount),
            status: item?.status,
          },
        },
      ],
    };
  };

  return { tableColumns, tableData, viewData };
};
